import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React from 'react';
import { useAudio } from '../../../../contexts';
import { LoadingRedoUndoOutlined, PauseFilled, PlayFilled, ReplayFilled, Icon } from '../../../Icon';
import { colorsMapper } from '../../AudioPlayer.utils';
import { useAudioStatus, STATUS } from './hooks/useAudioStatus';
import * as S from './styled';

var PlayButton = function PlayButton(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'green' : _ref$color,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading;

  var _useAudio = useAudio(),
      togglePlay = _useAudio.togglePlay,
      seek = _useAudio.seek,
      duration = _useAudio.duration;

  var status = useAudioStatus();

  var handleOnClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (status === STATUS.ended) seek(0);
              _context.next = 3;
              return togglePlay();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOnClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(S.Button, {
    onClick: handleOnClick,
    color: colorsMapper[color],
    disabled: !duration
  }, loading ? /*#__PURE__*/React.createElement(Icon, {
    spin: true,
    component: LoadingRedoUndoOutlined,
    color: "base.white",
    "data-test": "loading"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.Transition, {
    show: status === STATUS.paused,
    "data-test": STATUS.paused,
    reverse: true
  }, /*#__PURE__*/React.createElement(PlayFilled, {
    color: "base.white"
  })), /*#__PURE__*/React.createElement(S.Transition, {
    show: status === STATUS.playing,
    "data-test": STATUS.playing
  }, /*#__PURE__*/React.createElement(PauseFilled, {
    color: "base.white"
  })), /*#__PURE__*/React.createElement(S.Transition, {
    show: status === STATUS.ended,
    "data-test": STATUS.ended,
    reverse: true
  }, /*#__PURE__*/React.createElement(ReplayFilled, {
    color: "base.white"
  }))));
};

export { PlayButton };